import Vue from 'vue'
import { EventBus } from '@/router/bus'
import i18n from '@/i18n'
import FileSaver from 'file-saver'
import { setTabsInfo, getTabsInfo } from '@/utils/cookie'
import Papa from 'papaparse'
import Moment from 'moment'

Vue.mixin({
  methods: {
    isProductionEnvironment () {
      return process.env.NODE_ENV.toUpperCase() === 'production'.toUpperCase()
    },
    formatErrorResponse (error, limitError) {
      let apiErrorLink = Vue.$config.help_root + Vue.$apiConfig.apiCodes
      let errorMessage = ''
      let errorLink = ''
      let multipleErrors = []
      if (error.status === 422) {
        for (let i = 0; i < error.data.errors.length; i++) {
          let messageItem = {}
          if (error.data.errors[i].code === 1105 || error.data.errors[i].code === 1201 || error.data.errors[i].code === 1212) {
            var message = error.data.errors[i].message.split('-')
            messageItem.msg = i18n.t('apiStatusCodes.' + message[0])
            messageItem.link = apiErrorLink + error.data.errors[i].code
            multipleErrors.push(messageItem)
          } else {
            messageItem.msg = i18n.t('apiStatusCodes.' + error.data.errors[i].code)
            messageItem.link = apiErrorLink + error.data.errors[i].code
            multipleErrors.push(messageItem)
          }
        }
      } else if (error.status === 429) {
        if (limitError && limitError.length > 0) {
          errorMessage = i18n.t(limitError)
          errorLink = apiErrorLink + error.status
        } else {
          errorMessage = i18n.t('apiStatusCodes.429')
          errorLink = apiErrorLink + error.status
        }
      } else {
        if (error.data && error.data.status && error.data.status.code) {
          errorMessage = i18n.t('apiStatusCodes.' + error.data.status.code)
          errorLink = apiErrorLink + error.data.status.code
          if (error.data.additionalInformation && error.data.additionalInformation.length > 0) {
            errorMessage += ' : ' + error.data.additionalInformation
            errorLink = apiErrorLink + error.data.status.code
          }
        } else {
          errorMessage = i18n.t('apiStatusCodes.' + error.status)
          errorLink = apiErrorLink + error.status
        }
      }
      EventBus.$emit('alert', {
        variant: 'danger',
        message: errorMessage,
        link: errorLink,
        errors: multipleErrors
      })
    },
    formatDate (date) {
      if (date === null || date === undefined) { return '' }
      let formattedDate = new Date(date)
      return Moment(date).format(this.$store.getters.dateFormat) + ' ' + formattedDate.toLocaleTimeString(this.$store.getters.dateLocale)
    },
    formatShortDate (date) {
      if (date === null || date === undefined) { return '' }
      return Moment(date).format(this.$store.getters.dateFormat)
    },
    formatAmount (amount) {
      if (amount === null || amount === undefined) { return '' }
      let decimalSep = this.$store.getters.decimalFormat === ',' ? '.' : ','
      let val = (amount / 1).toFixed(2)
      if (this.$store.getters.decimalFormat === ',') {
        val = val.replace('.', ',')
      }
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, decimalSep)
    },
    convertCSVseparator (data) {
      let parsedData = Papa.parse(new TextDecoder('utf-8').decode(data))
      return Papa.unparse(parsedData, {delimiter: this.$store.getters.csvDelimmeter})
    },
    saveToFile (url, payload, filename, callback, transform = false) {
      this.$http.post(url, payload, { responseType: 'arraybuffer' })
      .then(response => {
        this.logConsole(response)
        var headers = response.headers
        let data = response.data
        if (transform !== false && typeof transform === 'function') {
          data = transform(data)
        }
        var blob = new Blob([data], {type: headers['content-type']})
        FileSaver.saveAs(blob, filename)
        callback()
      }, error => {
        this.logConsole(error)
        this.formatErrorResponse(error)
        callback()
      })
    },
    saveToJson (data, filename, callback) {
      this.logConsole(data)
      var blob = new Blob([JSON.stringify(data)], {type: 'application/json'})
      FileSaver.saveAs(blob, filename)
      callback()
    },
    saveToText (data, filename, callback) {
      this.logConsole(data)
      var blob = new Blob(data, {type: 'text/plain'})
      FileSaver.saveAs(blob, filename)
      callback()
    },
    transliterate (word) {
      var answer = ''
      var a = {}

      a['A'] = 'A'; a['a'] = 'a'
      a['B'] = 'Б'; a['b'] = 'б'
      a['V'] = 'В'; a['v'] = 'в'
      a['G'] = 'Г'; a['g'] = 'г'
      a['D'] = 'Д'; a['d'] = 'д'
      a['Đ'] = 'Ђ'; a['đ'] = 'ђ'
      a['E'] = 'Е'; a['e'] = 'е'
      a['Ž'] = 'Ж'; a['ž'] = 'Ж'
      a['Z'] = 'З'; a['z'] = 'з'
      a['I'] = 'И'; a['i'] = 'и'
      a['J'] = 'Ј'; a['j'] = 'ј'
      a['K'] = 'К'; a['k'] = 'к'
      a['L'] = 'Л'; a['l'] = 'л'
      a['Lj'] = 'Љ'; a['lj'] = 'љ'
      a['M'] = 'М'; a['m'] = 'м'
      a['N'] = 'Н'; a['n'] = 'н'
      a['NJ'] = 'Њ'; a['nj'] = 'њ'
      a['O'] = 'О'; a['o'] = 'о'
      a['P'] = 'П'; a['p'] = 'п'
      a['R'] = 'Р'; a['r'] = 'р'
      a['S'] = 'С'; a['s'] = 'с'
      a['T'] = 'Т'; a['t'] = 'т'
      a['Ć'] = 'Ћ'; a['ć'] = 'ћ'
      a['U'] = 'У'; a['u'] = 'у'
      a['F'] = 'Ф'; a['f'] = 'ф'
      a['H'] = 'Х'; a['h'] = 'х'
      a['C'] = 'Ц'; a['c'] = 'ц'
      a['Č'] = 'Ч'; a['č'] = 'ч'
      a['DŽ'] = 'Џ'; a['dž'] = 'џ'
      a['Š'] = 'Ш'; a['š'] = 'ш'

      for (let i in word) {
        if (word.hasOwnProperty(i)) {
          if (a[word[i]] === undefined) {
            answer += word[i]
          } else {
            answer += a[word[i]]
          }
        }
      }
      return answer
    },
    toBoldLatin (word) {
      var answer = ''
      var a = {}

      a['А'] = 'a'; a['а'] = 'a'
      a['Б'] = 'b'; a['б'] = 'b'
      a['В'] = 'v'; a['в'] = 'v'
      a['Г'] = 'g'; a['г'] = 'g'
      a['Д'] = 'd'; a['д'] = 'd'
      a['Ђ'] = 'dj'; a['ђ'] = 'dj'
      a['Е'] = 'e'; a['е'] = 'e'
      a['Ж'] = 'z'; a['ж'] = 'z'
      a['З'] = 'z'; a['з'] = 'z'
      a['И'] = 'i'; a['и'] = 'i'
      a['Ј'] = 'j'; a['ј'] = 'j'
      a['К'] = 'k'; a['к'] = 'k'
      a['Л'] = 'l'; a['л'] = 'l'
      a['Љ'] = 'lj'; a['љ'] = 'lj'
      a['М'] = 'm'; a['м'] = 'm'
      a['Н'] = 'n'; a['н'] = 'n'
      a['Њ'] = 'nj'; a['њ'] = 'nj'
      a['О'] = 'o'; a['о'] = 'o'
      a['П'] = 'p'; a['п'] = 'p'
      a['Р'] = 'r'; a['р'] = 'r'
      a['С'] = 's'; a['с'] = 's'
      a['Т'] = 't'; a['т'] = 't'
      a['Ћ'] = 'c'; a['ћ'] = 'c'
      a['У'] = 'u'; a['у'] = 'u'
      a['Ф'] = 'f'; a['ф'] = 'f'
      a['Х'] = 'h'; a['х'] = 'h'
      a['Ц'] = 'c'; a['ц'] = 'c'
      a['Ч'] = 'c'; a['ч'] = 'c'
      a['Џ'] = 'dz'; a['џ'] = 'dz'
      a['Ш'] = 's'; a['ш'] = 's'
      a['Č'] = 'c'; a['č'] = 'c'
      a['Ć'] = 'c'; a['ć'] = 'c'
      a['Š'] = 's'; a['š'] = 's'
      a['Đ'] = 'dj'; a['đ'] = 'dj'
      a['Ž'] = 'z'; a['ž'] = 'z'

      for (let i in word) {
        if (word.hasOwnProperty(i)) {
          if (a[word[i]] === undefined) {
            var letters = /^[0-9a-zA-Z ]+$/
            if (word[i].match(letters)) {
              answer += word[i]
            }
          } else {
            answer += a[word[i]]
          }
        }
      }
      return answer
    },
    saveTabState (tabDescription, tabState) {
      setTabsInfo(tabDescription, tabState)
    },
    loadTabState (tabDescription) {
      return getTabsInfo(tabDescription)
    },
    changeTabState (self, tabRef, tabDescription) {
      let namedTabTitle = ''
      for (let i = 0; i < self.headers.length; i++) {
        if (self.headers[i].value.localeCompare(tabDescription) === 0) {
          namedTabTitle = self.headers[i].title
          break
        }
      }

      for (let i = 0; i < tabRef.tabs.tabs.length; i++) {
        if (tabRef.tabs.tabs[i].title.localeCompare(namedTabTitle) === 0) {
          self.tabIndex = i
          break
        }
      }
    },
    getTabHeader (index) {
      let title = this.$refs.tabs.tabs[index].title
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].title.localeCompare(title) === 0) {
          return this.headers[i]
        }
      }
    },
    browserIE11 () {
      return false || !!document.documentMode
    },
    browserFirefox () {
      return typeof InstallTrigger !== 'undefined'
    },
    helpLink (linkRoute) {
      return (Vue.$config.help_root + '/' + linkRoute).replace(/([^:]\/)\/+/g, '$1')
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins/helper.js